import React from "react";

const ViewFinder = () => {
  return (
    <div
      style={{
        height: "5px",
        width: "5px",
        backgroundColor: "white",
        borderRadius: "50%",
        border: "solid 1px gray",
        margin: "auto",
      }}
    />
  );
};

export default ViewFinder;
